import "./bootstrap";
import "../css/app.css"; // Import Tailwind CSS
import { createApp } from "vue";
import { createPinia } from "pinia";
// Create Vue 3 app instance
const app = createApp({});
// Auto-register Vue components from resources/views
// Using require.context for webpack compatibility
const requireViewComponents = require.context("../views", true, /\.vue$/);
requireViewComponents.keys().forEach((fileName) => {
    const component = requireViewComponents(fileName);
    // Simple: just get filename without extension
    const componentName = fileName
        .split("/")
        .pop()
        ?.replace(/\.vue$/, ""); // Remove .vue extension
    if (componentName && component.default) {
        app.component(componentName, component.default);
    }
});
app.use(createPinia());
// Mount the app to the DOM
app.mount("#app");
